import React from "react";

export class MultiLine extends React.Component<any, any> {

    render() {
        let i = 0;
        if (this.props.items.length === 0) {
            return '';
        }
        return (
            <>
                {this.props.items.map(function (elem: string) {
                    if (i++ === 0) {
                        return elem;
                    }
                    let index = 'ml' + i;
                    return (<span key={index}><br/>{elem}</span>);
                })}
            </>
        );
    }

}